<template>

    <nav class="navbar navbar-expand-lg menu" v-if="showMenu">  
        <b-col cols="1">          
           <b-img @click="modalShow=true" left src="@/images/gear.png" :title="$t('general.menu')" fluid></b-img>
            
        </b-col>

        <b-col cols="10">
            <b-img center src="@/images/logos.png" fluid></b-img>
        </b-col>

        <b-col cols="1">
            <router-link :to="{name:'slide33',params:{lang:lang}}"><b-img right src="@/images/question-mark.png" :title="$t('general.help')" fluid></b-img></router-link>
        </b-col>

        <!-- Modal -->
         <b-modal v-model="modalShow" id="modal_password" :title="$t('Menu.text1')" effect="fade/zoom" 
    :ok-title="modalButtonText" :cancel-title="$t('Menu.text2')" @ok="submitPass" @cancel="cancelAction">
        <form @submit.prevent="submitPass" role="form" method="post">
            <div class="form-group">
                <label><p>{{ $t('Menu.text3') }}</p></label>
                <input class="form-control" type="password" v-model="menuPass" >
                <label v-if="!correctPass" class="danger"><p>{{ $t('Menu.text4') }}</p></label>
            </div>
        </form>
    </b-modal>

    </nav>
   
</template>

<script>
import {mapState} from 'vuex';
export default {   
    data(){
        return{
            modalShow: false,
            correctPass: true,
            menuPass: ''
        }
    },     
    computed: {
        ...mapState(['showMenu','lang','Menu','slide0Password']),
        modalButtonText(){
            return this.$t('Menu.text5'); 
        }  
    },
    methods: {
        submitPass(bvModalEvt){
          bvModalEvt.preventDefault();
          if(this.menuPass  == this.slide0Password ){
            this.menuPass='';
            this.modalShow=false;
            this.correctPass=true,
            this.$router.push("/slide32/"+this.lang);
          }else{
            this.correctPass = false;
            this.menuPass='';
          }
        },
        cancelAction(){
          this.menuPass='';
          this.correctPass=true;
        }, 
    },
    mounted(){
        this.menuPass='';
    }
}
</script>


<style scoped>
    
    .menu{
        background-color: #253789;
        width: 100% !important;
    }

    .danger{
    color: red;
    }
     
</style>


